var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"danmu-container",style:({background:_vm.background})},[(_vm.showItem)?_c('div',{staticClass:"danmu-box"},[_c('div',{staticClass:"box-user"},[(_vm.danmuItem.description)?_c('span',{staticClass:"box-description"},[_vm._v(_vm._s(_vm.danmuItem.description))]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }